export default {
  props: [ 'id', 'options', 'context'],
  methods: {
    update (options) {
      let payload = {
        id: this.id,
        options
      }
      this.$emit('update', payload)
    }
  }
}
